import React, { Component } from 'react';
import './ContextMenu.css'

class ContextMenu extends Component {
    state = {
        visible: false,
    };
    
    componentDidMount() {

    };

    componentWillUnmount() {

    }

    createMenu=()=>{
        let disbaleStyle = {
            pointerEvents:"none",
        }

        let disbaleStyleText = {
            color:"#a1a1a1",
        }

        if(this.props.invokeFrom === "EventList")
        {
            return (
                <div>
                    <div className={"ContextMenuOption"} style={this.checkDeleteAvaliable()} onClick={(e)=>this.onClick(e,"delete")}><div className={"ContextMenuOptionInner"} style={this.checkDeleteAvaliableForText()}>刪除</div></div>
                    <div className={"ContextMenuOption"} style={disbaleStyle} onClick={(e)=>this.onClick(e,"print")}><div className={"ContextMenuOptionInner"} style={disbaleStyleText}>列印</div></div>
                </div>
            )
        }
        else if(this.props.invokeFrom === "abstractBackgroundImage") 
        {
            return(
                <div>
                    <div className={"ContextMenuOption"} style={this.checkDeleteAvaliable()} onClick={(e)=>this.onClick(e,"delete")}><div className={"ContextMenuOptionInner"} style={this.checkDeleteAvaliableForText()}>刪除</div></div>
                    <div className={"ContextMenuOption"} style={disbaleStyle}><div className={"ContextMenuOptionInner"} style={disbaleStyleText}>排序上移</div></div>
                    <div className={"ContextMenuOption"} style={disbaleStyle}><div className={"ContextMenuOptionInner"} style={disbaleStyleText}>排序下移</div></div>
                </div>
            )
        }
        else if(this.props.invokeFrom === "contentBody" || this.props.invokeFrom === "contentContainer")
        {
            return(
            <div>
                <div className={"ContextMenuOption"} style={this.checkCopyAvaliable()} onClick={(e)=>this.onClick(e,"copy")}><div className={"ContextMenuOptionInner"}style={this.checkCopyAvaliableForText()}>複製</div></div>
                <div className={"ContextMenuOption"} style={this.checkPasteAvaliable()} onClick={(e)=>this.onClick(e,"paste")}><div className={"ContextMenuOptionInner"} style={this.checkPasteAvaliableForText()}>貼上</div></div>
                <div className={"ContextMenuOption"} style={this.checkDeleteAvaliable()} onClick={(e)=>this.onClick(e,"delete")}><div className={"ContextMenuOptionInner"} style={this.checkDeleteAvaliableForText()}>刪除</div></div>
                <div className={"ContextMenuOption"} style={disbaleStyle}><div className={"ContextMenuOptionInner"} style={disbaleStyleText}>群組</div></div>
                <div className={"ContextMenuOption"} style={disbaleStyle}><div className={"ContextMenuOptionInner"} style={disbaleStyleText}>解散群組</div></div>
            </div>
            )
        }
    }

    onClick=(e,type)=>{
        e.stopPropagation()
        switch(type){
            case "copy" :
                this.props.getCommand('copy')
                break 
            case "paste" :
                this.props.getCommand('paste')
                break
            case "delete" :
                this.props.getCommand('delete')
                break
            case "cancel" :
                this.props.getCommand('cancel')
                break
            default:
                break
        }
    }

    checkCopyAvaliable=()=>{
        let output = null
        let disbaleStyle = {
            pointerEvents:"none",
        }
        if(this.props.invokeFrom === "contentBody")
        {
            output= disbaleStyle
        }
        return output
    }

    checkCopyAvaliableForText=()=>{
        let output = null
        let disbaleStyleText = {
            color:"#a1a1a1",
        }
        if(this.props.invokeFrom === "contentBody")
        {
            output= disbaleStyleText
        }
        return output
    }

    checkPasteAvaliable=()=>{
        let output = null
        let disbaleStyle = {
            pointerEvents:"none",
        }
        if(this.props.invokeFrom === "contentContainer" )
        {
            output= disbaleStyle
        }

        if(this.props.prevCommand !== "copy")
        {
            output= disbaleStyle
        }
        return output
    }

    checkPasteAvaliableForText=()=>{
        let output = null
        let disbaleStyleText = {
            color:"#a1a1a1",
        }
        if(this.props.invokeFrom === "contentContainer")
        {
            output= disbaleStyleText
        }

        if(this.props.prevCommand !== "copy")
        {
            output= disbaleStyleText
        }
        return output
    }

    checkDeleteAvaliable=()=>{
        let output = null
        let disbaleStyle = {
            pointerEvents:"none",
        }
        if(this.props.invokeFrom === "contentBody")
        {
            output= disbaleStyle
        }
        return output
    }

    checkDeleteAvaliableForText=()=>{
        let output = null
        let disbaleStyleText = {
            color:"#a1a1a1",
        }
        if(this.props.invokeFrom === "contentBody")
        {
            output= disbaleStyleText
        }
        return output
    }

    
    render() {
        let ContextMenuStyle = {
            position:"fixed",
            left: this.props.pos.x,
            top:this.props.pos.y,
            width:100,
            backgroundColor:"#ffffff",
            border:"1px solid #797979",
            zIndex:1400
        }

        
    
        return(
            <div style={ContextMenuStyle} onClick={(e)=>this.onClick(e,"cancel")}>
                {this.createMenu()}    
            </div>
        )
    };
}

export default ContextMenu